import { ISuperCustomerItem } from 'apps/federation/src/app/customers-module/models';

import { ISuperCustomersState } from './state';


export function getSuperCustomerById(state: ISuperCustomersState, id: number): ISuperCustomerItem {
	return !!state.list.list && state.list.list.items.find(i => i.id === id);
}
